var Education = "Bildungswesen";
var Enterprise = "Enterprise";
var CompanyType = {
	"Company type": "Firmentyp",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "Regierung – Bund",
	"Government - State & local": "Regierung – Bundesland und Kommune",
	"Non-profit": "Gemeinnützige Organisation",
	"Self employed": "Selbständig",
	"Small-medium business": "Kleines oder mittelständisches Unternehmen",
	"Start-up": "Startup",
	"Not applicable": "Nicht anwendbar"
};

export { Education, Enterprise, CompanyType as default };
